module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-dash"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "block"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "textblock"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "version"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.version) + "\n\t\t\t\t")])])]), _vm._v(" "), (_vm.registrationCode) ? _c('div', {
    staticClass: "regcode"
  }, [_c('p', [_vm._v("To register this client, please visit the admin panel and enter the following code:")]), _vm._v(" "), _c('p', {
    staticClass: "code"
  }, [_vm._v(_vm._s(_vm.registrationCode))])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "smpte-bars"
  }, [_c('div', {
    staticClass: "stripe med-gray"
  }), _vm._v(" "), _c('div', {
    staticClass: "stripe lt-gray"
  }), _vm._v(" "), _c('div', {
    staticClass: "stripe med-yellow"
  }), _vm._v(" "), _c('div', {
    staticClass: "stripe med-cyan"
  }), _vm._v(" "), _c('div', {
    staticClass: "stripe green"
  }), _vm._v(" "), _c('div', {
    staticClass: "stripe magenta"
  }), _vm._v(" "), _c('div', {
    staticClass: "stripe med-red"
  }), _vm._v(" "), _c('div', {
    staticClass: "stripe med-blue"
  }), _vm._v(" "), _c('div', {
    staticClass: "stripe med-gray"
  }), _vm._v(" "), _c('div', {
    staticClass: "pill lt-cyan"
  }), _vm._v(" "), _c('div', {
    staticClass: "pill dk-purple"
  }), _vm._v(" "), _c('div', {
    staticClass: "pill lt-gray"
  }), _vm._v(" "), _c('div', {
    staticClass: "pill lt-blue"
  }), _vm._v(" "), _c('div', {
    staticClass: "pill lt-yellow"
  }), _vm._v(" "), _c('div', {
    staticClass: "pill lt-purple"
  }), _vm._v(" "), _c('div', {
    staticClass: "pill gradient"
  }), _vm._v(" "), _c('div', {
    staticClass: "pill lt-red"
  }), _vm._v(" "), _c('div', {
    staticClass: "square dk-gray"
  }), _vm._v(" "), _c('div', {
    staticClass: "square black"
  }), _vm._v(" "), _c('div', {
    staticClass: "square white"
  }), _vm._v(" "), _c('div', {
    staticClass: "square black"
  }), _vm._v(" "), _c('div', {
    staticClass: "square black1"
  }), _vm._v(" "), _c('div', {
    staticClass: "square black2"
  }), _vm._v(" "), _c('div', {
    staticClass: "square black3"
  }), _vm._v(" "), _c('div', {
    staticClass: "square black4"
  }), _vm._v(" "), _c('div', {
    staticClass: "square dk-gray"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": "images/logo-emblem.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashportal"
  }, [_c('strong', [_vm._v("Dash")]), _vm._v("Portal\n\t\t\t\t")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-54d8ba18"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/loading-dash.vue
// module id = 572
// module chunks = 0